import React from "react";
import IconTemperature from "./IconTemperature";

type Props = {
  isOn: boolean;
  title: string;
  value: string;
  color: string;
  onClick: () => void;
};
export default function TemperatureCard({ isOn, title, value, color, onClick }: Props) {
  const foregroundColor = isOn ? "Black" : "#C4C4C4";
  const fillColor = isOn ? color : "#C4C4C4";

  return (
    <div
      key={title}
      onClick={onClick}
      style={{
        width: 330,
        height: 56,
        border: "1px solid #C4C4C4",
        borderRadius: 5,
        display: "flex",
        alignItems: "center",
        fontSize: 14,
        lineHeight: "16px",
        color: foregroundColor,
        margin: "8px 8px",
      }}
    >
      <IconTemperature color={fillColor} />
      <div
        style={{
          flexGrow: 1,
          textAlign: "left",
        }}
      >
        {title}
      </div>
      <div
        style={{
          marginRight: 20,
        }}
      >
        {value}
      </div>
    </div>
  );
}
